import { Button, DatePicker, Form, Input, Select, Switch } from 'antd';
import { useDispatch } from 'react-redux';
import { omit } from 'lodash';
import { setSearchImport } from '../../import/import-actions';
import { useLocation, useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';

function SearchImport() {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { RangePicker } = DatePicker;
  const { Option } = Select;
  const data = useLocation();
  const importDetails: any = data.state;
  const history = useHistory();
  useEffect(() => {
    if (importDetails) {
      const details = {
        fileName: importDetails?.fileName,
        uploadedFileBy: importDetails?.uploadedFileBy,
      };
      form.setFieldsValue(details);
      dispatch(setSearchImport({ ...details, page: 0, size: 15 }));
      history.replace('/import');
    }
  }, [importDetails]);

  const onSubmit = (formData) => {
    const { uploadedDate, ...data } = formData;
    const searchDetails = {
      from: uploadedDate && uploadedDate[0] ? uploadedDate[0].format('YYYY-MM-DD') : null,
      to: uploadedDate && uploadedDate[1] ? uploadedDate[1].format('YYYY-MM-DD') : null,
      fileName: data?.fileName ? data?.fileName : null,
      uploadedFileBy: data?.uploadedFileBy ? data?.uploadedFileBy : null,
      page: 0,
      size: 15,
    };
    dispatch(setSearchImport(searchDetails));
  };

  return (
    <div className='search-container'>
      <Form
        form={form}
        layout='vertical'
        className='search-container'
        onFinish={(formData) => {
          onSubmit(formData);
        }}
      >
        <Form.Item key='fileName' label={'File Name'} name='fileName' className='label-text input-field'>
          <Input allowClear />
        </Form.Item>
        <Form.Item key='uploadedFileBy' label={'Upload By'} name='uploadedFileBy' className='label-text input-field'>
          <Input allowClear />
        </Form.Item>
        <Form.Item key='uploadedDate' name='uploadedDate' label='Select Upload Date Range' className='label-text'>
          <RangePicker allowEmpty={[true, true]} format={['YYYY-MM-DD']} separator='-' inputReadOnly />
        </Form.Item>
        <Form.Item className='search-btn'>
          <Button type='primary' htmlType='submit'>
            SEARCH
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}

export default SearchImport;
